import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import CloseIcon from "@mui/icons-material/Close";
import { anatomyConstants } from "../../../constants/anatomyConstants";

const CameraSliderModal = ({
  currentIndex,
  setCurrentIndex,
  maxIndex,
  moveCameraToIndex,
  autoMoveCamera,
  stopAutoMoveCamera,
  isMobile,
}) => {
  const handleSliderChange = (e) => {
    const newIndex = parseInt(e.target.value, 10);
    setCurrentIndex(newIndex);
    moveCameraToIndex(newIndex);
  };

  const decrementIndex = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      moveCameraToIndex(newIndex);
    }
  };

  const incrementIndex = () => {
    if (currentIndex < maxIndex) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      moveCameraToIndex(newIndex);
    }
  };

  // Check if mobile portrait (upside down) view
  const isMobilePortrait =
    isMobile &&
    typeof window !== "undefined" &&
    window.innerWidth < window.innerHeight;

  return (
    <div
      className={`absolute ${
        isMobilePortrait ? "bottom-20 right-20" : "bottom-1 left-[17rem]"
      } w-auto md:w-1/4 flex flex-col items-start z-50`}
    >
      <div
        className="relative flex flex-col items-center space-y-2 p-2 pt-7 pb-3 rounded bg-white shadow-lg border border-gray-200"
        style={{
          "--main-color": anatomyConstants.mainColor,
          "--main-color-bold": anatomyConstants.mainColorBold,
        }}
      >
        <input
          type="range"
          min="0"
          max={maxIndex}
          step="1"
          value={currentIndex}
          onChange={handleSliderChange}
          className="w-full accent-[var(--main-color)]"
        />
        {/* Buttons and text row */}
        <div className="flex items-center space-x-2">
          <button
            onClick={(e) => {
              e.stopPropagation();
              decrementIndex();
            }}
            className="p-1 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)] border border-[#0000001A]"
          >
            <ArrowBackIosNewRoundedIcon />
          </button>
          <label className="text-gray-700 text-sm md:text-xs font-inter">
            Point: {currentIndex + 1} / {maxIndex + 1}
          </label>
          <button
            onClick={(e) => {
              e.stopPropagation();
              incrementIndex();
            }}
            className="p-1 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)] border border-[#0000001A]"
          >
            <ArrowForwardIosRoundedIcon />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              autoMoveCamera();
            }}
            className="p-1 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)] border border-[#0000001A]"
          >
            <PhotoCameraOutlinedIcon />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              stopAutoMoveCamera();
            }}
            className="p-1 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)] border border-[#0000001A]"
          >
            <CloseIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CameraSliderModal;
